import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';
import FareRule from './../models/FareRule';

const initialState = {
    isFetching: false,
    isFetched: false,
    fareRules: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    detail: {
        fareRule: new FareRule()
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.FARE_RULE_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.FARE_RULE_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                fareRules: action.fareRules.result,
                pageSize: action.fareRules.pageSize,
                pageIndex: action.fareRules.pageIndex,
                totalCount: action.fareRules.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize))
            };
        case Types.FARE_RULE_LIST_FAIL:
            return { ...state, isFetching: false, isFetched: true, fareRules: [] };
        case Types.FARE_RULE_DETAIL_ACTION:
            return { ...state, isFetching: true, detail: initialState.detail };
        case Types.FARE_RULE_DETAIL_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                detail: {
                    fareRule: action.fareRule
                }
            };
        case Types.FARE_RULE_DETAIL_FAIL:
            return { ...state, isFetching: false, isFetched: true };
        case Types.FARE_RULE_DETAIL_CREATE_ACTION:
            return { ...state, isFetching: true };
        case Types.FARE_RULE_DETAIL_DELETE_ACTION:
            return { ...state, isFetching: true };
        case Types.FARE_RULE_DETAIL_UPDATE_ACTION:
            return { ...state, isFetching: true };
        case Types.FARE_RULE_CREATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.FARE_RULE_CREATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.FARE_RULE_DELETE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.FARE_RULE_DELETE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.FARE_RULE_UPDATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.FARE_RULE_UPDATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.FARE_RULE_FAIL:
            return { ...state, isFetching: false, isFetchingUpdate: false, isFetched: true };
        default: 
            return state
    }
}
